const ibantools = require("ibantools");

export default function isValidIBAN(value) {
  if (typeof value !== "string") {
    return false;
  }

  return ibantools.validateIBAN(value).valid;
}
